import { ICashFlowBase, ICashFlowResponse } from '../types';

export interface IIncomeMutation extends ICashFlowBase {
  incomeName: string;
  settlementId: string;
}

export interface ICreateIncome extends IIncomeMutation {
  labelId: string;
}

export interface IUpdateIncome extends Omit<IIncomeMutation, 'settlementId'> {
  settlementIncomeId: string;
}

export interface IIncomeResponse extends ICashFlowResponse {
  incomeName: string;
  incomeType: INCOME_TYPE
}

export enum INCOME_TYPE {
  unknown = -1,
  cost = 0,
  basic = 1,
  repaysAdvance = 2,
  repaysCost = 3,
}
